import { render } from "./ProductArchive.vue?vue&type=template&id=b3482120"
import script from "./ProductArchive.vue?vue&type=script&lang=js"
export * from "./ProductArchive.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataActions/ProductArchive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b3482120"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b3482120', __exports__)) {
    console.log('reload')
    api.reload('b3482120', __exports__)
  }
  
  module.hot.accept("./ProductArchive.vue?vue&type=template&id=b3482120", () => {
    console.log('re-render')
    api.rerender('b3482120', render)
  })

}


export default __exports__